import React from "react";
import GenericDialog from "@components/GenericDialog/GenericDialog";
import type { DelayView } from "@services/drybulkCargoOperationsApi";
import { useTranslation } from "react-i18next";
import { DRYBULK_CARGO_OPS_LANG_BASE } from "../constants";
import { useGatedOpen } from "../hooks/usePollingGate";
import { formatInstant } from "../utils/formatInstant";

const L = `${DRYBULK_CARGO_OPS_LANG_BASE}.detail.delays.remove-dialog`;

/** DBCO-0059 (AC3) - asks before a delay is removed; it holds the polling gate while open. */
const DeleteDelayDialog: React.FC<{
  delay: DelayView;
  isSubmitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}> = ({ delay, isSubmitting, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  useGatedOpen(true);
  return (
    <GenericDialog
      open
      testId="delete-delay-dialog"
      title={t(`${L}.title`)}
      cancelButtonText={t(`${L}.cancel`)}
      confirmButtonText={t(`${L}.confirm`)}
      handleCloseDialog={onCancel}
      confirmAction={onConfirm}
      isSubmitting={isSubmitting}
      elementContent={
        <span data-testid="delete-delay-dialog-message">
          {t(`${L}.message`, { code: delay.delayCode, start: formatInstant(delay.startAt) })}
        </span>
      }
    />
  );
};

export default DeleteDelayDialog;
